<template>
    <a-modal v-model="visibles" width="1000px" :footer="null" :maskClosable="false" :confirmLoading="loading" title="发送短信" centered class="modal-box" @ok="handlerSubmit" @cancel="handleCancel">
        <a-spin :spinning="loading">
            <a-row :gutter="[20,20]">
                <a-col :lg="16">
                    <a-form :form="form" :labelCol="{span:4}" :wrapperCol="{span:19}">
                        <a-form-item class="mb10" label="会场名称">
                            <a-input :disabled="true" autocomplete="off" v-decorator="['hall_name']" />
                        </a-form-item>
                        <a-form-item class="mb10" label="号码来源">
                            <a-select @change="handleSelectChange" v-decorator="['layout_id']">
                                <a-select-option :value="-1">自定义（本会场人员手机号码）</a-select-option>
                                <a-select-option :value="-2">未分配座位（本会场）</a-select-option>
                                <a-select-option :value="0">全部会场</a-select-option>
                                <a-select-option v-for="(item,index) in layoutList" :key="index" :value="item.id">{{item.area_name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item v-if="form.getFieldValue('layout_id') == -1" extra="批量时每一个号码占一行" class="mb10" label="手机号码">
                            <a-textarea v-decorator="['mobile',{ rules: [{ required: true, message: '请输入手机号码'}] }]" placeholder="批量时每一个号码占一行" :auto-size="{ minRows: 3, maxRows: 5 }" />
                        </a-form-item>
                        <a-form-item extra="一次发放短信内容的最长字符数不超过500字符，短信内容1条/70字符（不足按70字符计算）" class="mb10" label="短信内容">
                            <a-textarea ref="inputArea" @blur="handleBlurEvent" v-decorator="['content',{ rules: [{ required: true, message: '请输入短信内容'}] }]" placeholder="Controlled autosize" :auto-size="{ minRows: 3, maxRows: 5 }" />
                        </a-form-item>
                        <a-form-item class="mb10" label="标签替换">
                            <a-row :gutter="[10,10]">
                                <a-col v-for="(it,key,idx) in tagList" :key="idx" :xs="6">
                                    <a-button @click="handleTagSelect(key)" class="btn-item">{{tagList[key]}}</a-button>
                                </a-col>
                            </a-row>
                            <div slot="extra">
                                <p class="error-color">替换标签只能替换系统内注册的用户，非系统用户无法替换</p>
                            </div>
                        </a-form-item>
                        <a-form-item class="mb10" label="短信签名">
                            <a-input autocomplete="off" v-decorator="['sign']" />
                            <div v-if="form.getFieldValue('content')" class="error-color" slot="extra">
                                <p>号码列表{{phoneNumber}}, 短信内容{{form.getFieldValue('content').length + (form.getFieldValue('sign') && (form.getFieldValue('sign').length + 2))}}字, 短信内容1条/70字符（不足按70字符计算）, 短信总数{{Math.ceil((form.getFieldValue('content').length + (form.getFieldValue('sign') && (form.getFieldValue('sign').length + 2))) / 70) * phoneNumber}}条</p>
                                <p>注意：如果短信内容包含标签，则短信内容字符以替换标签后的字符数为准！</p>
                            </div>
                        </a-form-item>
                        <a-form-item class="mb10" :colon="false" label=" ">
                            <a-button @click="handlerSubmit" style="width:120px" type="primary">预 览</a-button>
                        </a-form-item>
                    </a-form>
                </a-col>
                <a-col :lg="8">
                    <div class="yl_sms_box">
                        <div class="yl_text_scroll">
                            <div class="yl_text">
                                <div class="cont">
                                    <template v-if="form.getFieldValue('sign')">【{{form.getFieldValue('sign')}}】</template>    
                                    {{form.getFieldValue('content')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </a-col>
            </a-row>
        </a-spin>
    </a-modal>
</template>

<script>
const fields = ['hall_name','layout_id','mobile','content','sign'];
import pick from 'lodash.pick'
export default {
    name: "smsNotice",
    props: {},
    data() {
        return {
            loading: false,
            visibles: false,
            layoutList: [], // 会场区域列表
            tagList: {}, // 标签列表
            phoneNumber:0,
            form: this.$form.createForm(this),
        };
    },

    components: {},

    computed: {
       
    },

    methods: {
        show() {
            this.visibles = true;
            this.getTagData();
            this.getHallData();
        },

        // 获取光标位置
        handleBlurEvent(e){
            this.__cursorIndex = e.srcElement.selectionStart; 
        },

        // 标签替换
        handleTagSelect(name){
            name = '{'+name+'}';
            let content = this.form.getFieldValue('content');
            if(content.length < this.__cursorIndex){
                this.form.setFieldsValue({content:content+name});
            }else{
                let s1 = content.substring(0,this.__cursorIndex);
                let s2 = content.substring(this.__cursorIndex,content.length);
                this.form.setFieldsValue({content:s1+name+s2});
            }
            // this.$refs.inputArea.focus();
        },

        // 获取会场列表
        getHallData() {
            let { meeting_id,hall_id } = this.$route.params;
            this.$request.post({ url: 'getLayout2', data: { meeting_id,hall_id } }).then(res => {
                this.layoutList = res.data;
            })
        },

        // 获取替换标签
        getTagData() {
            let { meeting_id } = this.$route.params;
            this.$request.post({ url: 'getTag', data: { meeting_id} }).then(res => {
                let { tags,sign,content,hall_name } = res.data;
                this.tagList = tags;
                this.form.setFieldsValue({
                    sign,
                    content,
                    hall_name,
                    layout_id:-1,
                })
            })
        },

        // 获取会场人数
        getNumData(layout_id){
            let { meeting_id,hall_id } = this.$route.params;
            this.$request.post({ url: 'getNum', data: { meeting_id,hall_id,layout_id } }).then(res => {
                this.phoneNumber = res.num;
            })
        },

        // 下拉框改变事件
        handleSelectChange(e){
            // 选择会场区域
            if(e >= 0){
                this.getNumData(e);
            }else{
                this.phoneNumber = 0;
            }
        },

        handlerSubmit() {
            this.form.validateFields((errors, values) => {
                if(values['mobile']){
                    let mobile = this.form.getFieldValue('mobile');
                    values['mobile'] = mobile.replace('\n','|');
                }
                let { meeting_id,hall_id } = this.$route.params;
                values['meeting_id'] = meeting_id;
                values['hall_id'] = hall_id;
                if (!errors) {
                    this.$emit('ok',values);
                }
            })
        },
        handleCancel() {
            this.form.resetFields() // 清理表单数据（可不做）
        }
    },
    created() {
        // 防止表单未注册
        fields.forEach(v => this.form.getFieldDecorator(v));
    },
    mounted() {

    },
}
</script>

<style lang="less" scoped>
.yl_sms_box{
    margin: 0 auto;
    width: 300px;
    height: 524px;
    position: relative;
    background: url(https://files.sciconf.cn/asset/images/sms.jpeg) no-repeat;
    background-size: contain;
    .yl_text_scroll {
        width: 260px;
        height: 370px;
        overflow: auto;
        position: absolute;
        left: 20px;
        top: 135px;
    }
    .yl_text {
        word-break: break-all;
        width: 200px;
        min-height: 40px;
        padding: 10px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        right: 0px;
        top: 50px;
        color: #fff;
        font-size: 12px;
        background: url(https://files.sciconf.cn/asset/images/sms-text.png) left bottom no-repeat;
        background-size: contain;
        margin-bottom: 110px;
        .cont{
            position: relative;
            z-index: 2;
        }
        &:after {
            content: '';
            display: block;
            width: 193px;
            min-height: 20px;
            position: absolute;
            top: 0px;
            bottom: 20px;
            left: 0;
            background-color: #03D94A;
            border-top-left-radius: 15px;
            border-top-right-radius: 15px;
        }
    }
}
.error-color{
    color:@danger;
}
.btn-item{
    width:100%;
    display: block;
}
</style>
